/**
 * Collapsible transcripts attached to some videos
 */

(function() {
	let allTranscripts = document.querySelectorAll('.js-show-hide-transcript');
	[].forEach.call(allTranscripts, function(transcript) {
		transcript.addEventListener('click', function() {
			const isExpanded = this.getAttribute('aria-expanded') == 'true';
			const transcriptContent = document.querySelector('#' + this.getAttribute('aria-controls'));

			this.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
			transcriptContent.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
			transcriptContent.setAttribute('aria-live', isExpanded ? 'off' : 'assertive');
		});
	});
})();
